function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".8base-girl_svg__cls-3,.8base-girl_svg__cls-34,.8base-girl_svg__cls-35{fill:#f1f1f3}.8base-girl_svg__cls-3{opacity:.45}.8base-girl_svg__cls-4{fill:#e7ebf2}.8base-girl_svg__cls-11,.8base-girl_svg__cls-14,.8base-girl_svg__cls-21,.8base-girl_svg__cls-26,.8base-girl_svg__cls-45,.8base-girl_svg__cls-7{opacity:.5}.8base-girl_svg__cls-11,.8base-girl_svg__cls-14,.8base-girl_svg__cls-16,.8base-girl_svg__cls-21,.8base-girl_svg__cls-22,.8base-girl_svg__cls-25,.8base-girl_svg__cls-26,.8base-girl_svg__cls-27,.8base-girl_svg__cls-29,.8base-girl_svg__cls-35,.8base-girl_svg__cls-36,.8base-girl_svg__cls-39,.8base-girl_svg__cls-44,.8base-girl_svg__cls-45,.8base-girl_svg__cls-7,.8base-girl_svg__cls-9{mix-blend-mode:multiply}.8base-girl_svg__cls-23,.8base-girl_svg__cls-6,.8base-girl_svg__cls-7,.8base-girl_svg__cls-9{fill:#805743}.8base-girl_svg__cls-17,.8base-girl_svg__cls-23,.8base-girl_svg__cls-28{mix-blend-mode:screen}.8base-girl_svg__cls-16,.8base-girl_svg__cls-22,.8base-girl_svg__cls-23,.8base-girl_svg__cls-25,.8base-girl_svg__cls-39,.8base-girl_svg__cls-44,.8base-girl_svg__cls-9{opacity:.25}.8base-girl_svg__cls-10,.8base-girl_svg__cls-11,.8base-girl_svg__cls-39{fill:#f4bd0f}.8base-girl_svg__cls-13{fill:#ffd0c0}.8base-girl_svg__cls-14,.8base-girl_svg__cls-29{fill:#f2dad6}.8base-girl_svg__cls-15,.8base-girl_svg__cls-16,.8base-girl_svg__cls-17{fill:#8e648c}.8base-girl_svg__cls-17,.8base-girl_svg__cls-27{opacity:.15}.8base-girl_svg__cls-18{fill:#343434}.8base-girl_svg__cls-20,.8base-girl_svg__cls-21,.8base-girl_svg__cls-22{fill:#dfd9d5}.8base-girl_svg__cls-24,.8base-girl_svg__cls-28{fill:#d6e7f9}.8base-girl_svg__cls-25,.8base-girl_svg__cls-26,.8base-girl_svg__cls-27{fill:#a1c3e2}.8base-girl_svg__cls-28{opacity:.35}.8base-girl_svg__cls-36{fill:#e0e0e0}.8base-girl_svg__cls-37{fill:#fff}.8base-girl_svg__cls-38{fill:#ea4235}.8base-girl_svg__cls-43,.8base-girl_svg__cls-44,.8base-girl_svg__cls-45{fill:#4fd600}"), React.createElement("clipPath", {
  id: "8base-girl_svg__clip-path"
}, React.createElement("path", {
  d: "M444.5 398.3c18.5.13 24.5-20.39 29.29-32.3 7.2-17.81 15.75-40 36.07-44.72 21-4.85 33.25-9.46 38-20.42H6.16v262.25h432.35z",
  fill: "none"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  id: "8base-girl_svg__Shadow",
  className: "8base-girl_svg__cls-3",
  d: "M828.61 563.11c3.78 3.13-109.71 3.25-225.65 8.42-73.27 3.27-93.25 13.26-178.15 13.26-42.42 0-104.13-11.32-165.75-12.72-57.17-1.31-107 7.29-135.77 7.29C57.42 579.36 4 572.09 4 563.11s53.4-16.25 119.27-16.25c30.4 0 82.72 8.27 140.86 8.27 60 0 78.52-13.69 168.45-13.69 73.94 0 114.17 11.4 190.69 14.35 60.23 2.32 201.06 3.78 205.34 7.32z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "8base-girl_svg__cls-4",
  d: "M421.39 529.32c-24 0-51.26 9-59.66 16.82-5.06 4.69-4.33 15.3 6 15.3h129.79c10.29 0 11-10.61 6-15.3-8.41-7.79-35.64-16.82-59.67-16.82z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "8base-girl_svg__cls-4",
  d: "M447.29 526.65c0-5.59-4.45-5.59-6.47-5.59H424.4c-2.32 0-6.48 0-6.48 6v2.26a3.77 3.77 0 0 0 3.47 4h22.43a3.77 3.77 0 0 0 3.47-4zM458.67 406.49h-52.13l.53 3a10 10 0 0 0 9.85 8.25h31.37a10 10 0 0 0 9.85-8.25zM448.29 417.75h-31.37s7.48 54.65 7.48 103.31h16.42c0-48.66 7.47-103.31 7.47-103.31z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "8base-girl_svg__cls-6",
  d: "M558.8 211.48c-24.48-3.55-105.91-.42-124.73.52-12.27.62-25.34 33.5-30.53 44.14-7.4 15.16-15.72 42.45-21.85 44.73-27.64 10.3-38.81 15.68-38.81 27.49 0 16.84.45 29.78 3.22 47.78s14.92 30.35 32 30.35h99.3c37.34 0 51.66-35 53.6-46 .67-3.81-.82-7.89-9.73-9.89 16.48-5.64 17.35-8.88 20.71-17.43 7.37-18.83 25.09-73.72 29.16-102.65 1.45-10.37.1-17.23-12.34-19.04z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  className: "8base-girl_svg__cls-7",
  d: "M558.8 211.48c-24.48-3.55-105.91-.42-124.73.52-12.27.62-25.34 33.5-30.53 44.14-7.4 15.16-15.72 42.45-21.85 44.73-27.64 10.3-38.81 15.68-38.81 27.49 0 16.84.45 29.78 3.22 47.78s14.92 30.35 32 30.35h99.3c37.34 0 51.66-35 53.6-46 .67-3.81-.82-7.89-9.73-9.89 16.48-5.64 17.35-8.88 20.71-17.43 7.37-18.83 25.09-73.72 29.16-102.65 1.45-10.37.1-17.23-12.34-19.04z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  className: "8base-girl_svg__cls-6",
  d: "M554.91 295c-4.94 16-9.85 30.2-12.94 38.1-3.35 8.55-4.22 11.79-20.7 17.43-2.46.8-4.31 1.37-5.74 1.84-3.83 1.26-4.69 1.83-6.47 4.45-2.09 3.06-3.78 7.32-3.31 10.15a3.4 3.4 0 0 0 1.24 2.24c3.46 2.63 25.22-3.67 24-11.71a7.75 7.75 0 0 1 0 2.92c-1.94 11.06-16.26 46-53.6 46h-29.1c11.29 0 18.3-4.52 24.89-16.84 4.28-8 11.47-28.41 19.53-45.67 4.47-9.59 11.15-15.56 19.18-17.46 12.19-2.81 34.59-6.45 43.02-31.45z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  className: "8base-girl_svg__cls-9",
  d: "M571.13 230.48c-2.35 16.73-9.26 42.13-16.11 64.22 0 .11-.07.22-.11.33-8.43 25-30.83 28.61-43 31.49l-.79.2a21.69 21.69 0 0 1-12.75-.2c-4.51-1.29-136.25-11-143-9.45-2.95.69-5 .21-6.32-.86 5.95-4.95 16.5-9.3 32.71-15.34 6.13-2.28 14.45-29.57 21.84-44.73 1.93-3.94 4.93-10.93 8.57-18.2l152.16-25.08c7.29 2.89 8.01 9.06 6.8 17.62z"
});

var _ref9 =
/*#__PURE__*/
React.createElement("g", {
  id: "8base-girl_svg__Pillow"
}, React.createElement("path", {
  className: "8base-girl_svg__cls-10",
  d: "M472.19 370.12c-4.63 11.95-11.2 28.3-27.69 28.18-6.2 0-24.18.05-40.3 0-6.56-1.84-13.73-9.58-4.75-15.35 7.3-4.66 46.93-11.45 72.74-12.83z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-11",
  d: "M472.19 370.12c-2.5 6.46-5.57 14.2-10.46 19.93-8.31-1-19-2.92-32.32-.79-16.22 2.59-34.08.95-33.42-2.86a10 10 0 0 1 3.46-3.41c7.3-4.7 46.93-11.49 72.74-12.87zM459.56 392.33a21 21 0 0 1-15.06 6c-6.2 0-24.18.05-40.3 0-3.3-.93-6.76-3.35-8.23-6.26 3.82 4.15 14.29 3.27 26.84 3.13 14.61-.2 30.19.62 36.75-2.87z"
}));

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  className: "8base-girl_svg__cls-13",
  d: "M226.69 486.64c-7.54 8.55-20.69 25.71-31.93 40.44-22.42 29.38-44.14 11.18-36.81 2.24S178.09 501 190 478.26zm-112 .73c-16.68 20.38-39.79 40.92-44.78 45s15.83 28.16 41.54-4.23c7.55-9.51 22.73-21.62 31.11-28.23z"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  className: "8base-girl_svg__cls-14",
  d: "M226.68 486.64c-7.53 8.55-20.69 25.71-31.93 40.44-13.34 17.49-26.44 18.12-33.31 13.88 6.25-1.34 13.63-5.85 21.08-15.62s16.15-21.05 23.42-30.13c-7.1-.21-16.8-3.54-19.2-10.82 1.74-3.19 4.52-8.74 5.88-11.54zm-109.21-2.51c-1.08 1.27-5.23 6.2-7.28 8.6.35 6.43 10.51 10.81 13.32 11.44-7.48 6.21-15.78 13.62-20.77 19.9-11.53 14.54-22.08 17.7-29.74 16.39 6.69 5.84 21.53 9.06 38.49-12.32 7.56-9.51 22.73-21.62 31.12-28.23z"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  className: "8base-girl_svg__cls-14",
  d: "M198.7 521.91q-2 2.63-3.95 5.17c-22.41 29.38-44.13 11.18-36.81 2.24 1.5-1.82 3.22-4.08 5.11-6.71 0 .43-.06.88-.13 1.36-.89 6.4 1.81 11.37 10.92 9.86 8.32-1.38 18-6.21 22.86-10.45.94-.82 1.46-1.53 2-1.47zm-82.85.5c-4.73 4.12-14.1 8.8-22.17 10.14-8.84 1.45-11.45-3.36-10.59-9.55a14.45 14.45 0 0 0 .15-2.52c-6.32 5.93-11.29 10.26-13.3 11.91-5 4.08 15.83 28.16 41.53-4.23A84.15 84.15 0 0 1 118 521c-.63-.22-1.15.53-2.15 1.41z"
});

var _ref13 =
/*#__PURE__*/
React.createElement("g", {
  id: "8base-girl_svg__Pants"
}, React.createElement("path", {
  className: "8base-girl_svg__cls-15",
  d: "M142.59 499.91c36.25-29.26 67.89-45.15 96.69-89.5 41.33-.82 88.93-10.4 134-28.27 34.7-13.76 35.33-11.78 59.32-18.1 35-9.23 12.19-48.26 26.06-71.53h-64.57a153.15 153.15 0 0 1-8.34 18.2C298.31 330 235.38 362.35 212 375.64c-9.9 5.62-9.77 12.06-16.44 18.14-13.92 12.71-57 65.6-80.82 93.59-.02 7.01 13.52 14.13 27.85 12.54z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-16",
  d: "M142.59 499.91c36.25-29.26 67.89-45.15 96.69-89.5 41.33-.82 88.93-10.4 134-28.27 34.7-13.76 35.33-11.78 59.32-18.1 35-9.23 12.19-48.26 26.06-71.53h-64.57a153.15 153.15 0 0 1-8.34 18.2C298.31 330 235.38 362.35 212 375.64c-9.9 5.62-9.77 12.06-16.44 18.14-13.92 12.71-57 65.6-80.82 93.59-.02 7.01 13.52 14.13 27.85 12.54z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-16",
  d: "M432.6 364c-24 6.32-24.61 4.35-59.31 18.1-45.08 17.87-92.68 27.45-134 28.27-28.8 44.35-60.44 60.24-96.69 89.5a37.55 37.55 0 0 1-12.85-.81c35.1-34.86 68.49-54.18 95.06-92.35a11 11 0 0 1 8.63-4.75c16.07-.61 49.61-24.52 66.92-27.68 25.78-4.71 35.78 9.79 61.56-.43 34.7-13.75 35.32-11.78 59.31-18.1 31.12-8.21 16.53-40 22.68-63.28h14.77c-13.89 23.31 8.91 62.34-26.08 71.53z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-15",
  d: "M314.44 378.66c-23.86 54.46-52.05 66-87.75 108-15 5.1-33.74 2.14-36.67-8.38 16.83-35.79 52-92.86 75.84-127.79 2.55-3.74 1.45-8.88 8-16.08 15.17-16.77 65.54-25.24 148.33-23.68 7-7.63 24.53-18.2 32.19-18.2h42c-8.36 23.77 7.05 35.31 7.07 54.49 0 11.72-7.95 31.76-28.35 34.17-12.4 1.47-20.88-1.6-40.63-1.11-31.06.74-73.97 11.72-120.03-1.42z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-16",
  d: "M503.37 347c0 11.72-7.94 31.76-28.35 34.18-12.39 1.46-20.87-1.61-40.62-1.12-31 .76-73.91 11.74-120-1.4-23.86 54.46-52 66-87.75 108a46.77 46.77 0 0 1-15.76 2.43c31.17-40.51 68.22-67.73 90.35-119.59a9.21 9.21 0 0 1 10.57-5.34c43.16 10 83.08.16 112.34-.57 19.75-.48 28.24 2.59 40.63 1.12 20.41-2.41 28-18 25.64-29.5-2.55-12.31-8.54-26.29-7.65-42.68h13.5c-8.27 23.75 7.09 35.29 7.1 54.47z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-17",
  d: "M367.76 319.28c-4.23 2.45 21.81 9.91 40.22 7.93s47.35 4.81 59.78 5.09 5.92-12.17-1.72-14.72-22.09-2.84-39.65 0-47.87-4.58-58.63 1.7z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-16",
  d: "M503.23 343.91s-31.87 5.61-66.56.41c-32.17-4.82-70.36-15.44-100.56-9.71-65.25 12.37-63.31 1-54.66-6.3 17.31-10.43 52.42-16.51 104.3-17.6 2.09-4 6.34-12.37 8.33-18.2H496.3c-7.89 22.49 5.44 34.01 6.93 51.4z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-17",
  d: "M277.09 373.42c-5.51 19.65-30.2 23-43.9 50-4.35 8.57-14.82 10.8-10.95 4 6.78-16.5 40-67.09 44.46-70s15.62-2.66 10.39 16zM197.37 398.34c6-4.15 11.91 1.84 6.58 11.48-6.47 11.73-41.71 32.66-48.85 42.15-5.16 6.84-9.4 4.78-7.22.26 3.48-7.23 45.35-51.05 49.49-53.89z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-16",
  d: "M464.56 314c-14.77-2.67-37.18-3.23-42.42-3.26a44.24 44.24 0 0 1 4-3.77 111 111 0 0 1 38.52 6.48c.64.15.34.55-.1.55zM231.33 481.29q-2.29 2.59-4.65 5.35c-15 5.1-33.73 2.14-36.67-8.38.82-1.75 1.69-3.56 2.61-5.41 4.97 8.15 12.32 12.79 38.71 8.44zM146.66 496.67c-14.83-.13-27.49-5.62-29.19-12.54l-2.76 3.24c0 7 13.54 14.13 27.88 12.54z"
}));

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  className: "8base-girl_svg__cls-18",
  d: "M24.05 553.07c-1.05 2.2 1.53 4.49 4.84 4.92s76.11 1.33 85.79-1.32c1.73-.48 1.71-5.83.86-6.64z"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  className: "8base-girl_svg__cls-20",
  d: "M26.5 548.62c9.5-2.79 22.9-7.5 35.5-16.62 7.62-5.55 13.67-8.31 15.32-10.77 1.76-2.64 4.14-.87 3.35 4.78-.87 6.21 1.75 11 10.58 9.57 8.07-1.34 17.45-6 22.18-10.14 1.2-1 1.7-1.92 2.47-1.13 1.17 1.21-.21 5.51-1 9.5s1.12 13.93.58 16.27c-1.12 4.87-84.5 5.24-87.14 5.24-3.94-.05-7.66-4.98-1.84-6.7z"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  className: "8base-girl_svg__cls-21",
  d: "M77 523.63a13.76 13.76 0 0 0 .16-2.19l.18-.26c1.76-2.63 4.13-.87 3.35 4.79-.87 6.19 1.74 11 10.58 9.56 1.2-.2 2.43-.48 3.68-.81a17.43 17.43 0 0 1-5.3 1.28c-8.93.59-13.52-6.16-12.65-12.37zm38 10.13c.74-4 2.12-8.29.94-9.5-.75-.79-1.26.08-2.46 1.12-.34.3-.7.59-1.08.89-.31 1.58-.75 3.4-1.08 5.16-.74 4 1.12 13.92.58 16.26-1.13 4.87-84.5 5.25-87.14 5.25a4.36 4.36 0 0 1-.81-.07 5.45 5.45 0 0 0 4.48 2.41c2.65 0 86-.38 87.15-5.25.5-2.34-1.35-12.28-.58-16.27z"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  className: "8base-girl_svg__cls-22",
  d: "M115.54 550c-.84 3.66-48.24 4.78-72.8 5.11 9.07-3 34.29-8.38 42.12-12 6.3-2.91 23.93-8.41 30.1-9.38-.74 4.02 1.12 13.96.58 16.27z"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  className: "8base-girl_svg__cls-3",
  d: "M74.67 531.85c1.39 1.86-6.23 4.13-10.17 5.78s-16.66 5.25-18.4 3.67A98.47 98.47 0 0 0 62 532c4.57-3.33 8.57-5.65 11.4-7.52-.65 3.52.13 5.83 1.27 7.37z"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  className: "8base-girl_svg__cls-18",
  d: "M102.85 555.27c-1.08 2.28 1.59 4.64 5 5.08s78.48 1.37 88.46-1.36c1.78-.49 1.77-6 .89-6.85z"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  className: "8base-girl_svg__cls-20",
  d: "M105.39 550.69c9.74-2.88 23.6-7.74 36.6-17.19 7.87-5.72 14.1-8.57 15.8-11.11 1.81-2.71 4.27-.89 3.45 4.94-.89 6.39 1.81 11.37 10.92 9.86 8.32-1.38 18-6.21 22.86-10.46 1.24-1.08 1.76-2 2.55-1.16 1.21 1.25-.22 5.69-1 9.8s1.16 14.35.6 16.77c-1.15 5-87.13 5.41-89.85 5.41-4.11 0-7.94-5.09-1.93-6.86z"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  className: "8base-girl_svg__cls-21",
  d: "M157.44 524.92a14.59 14.59 0 0 0 .16-2.26l.19-.27c1.81-2.71 4.26-.89 3.45 4.94-.89 6.39 1.8 11.37 10.91 9.86 1.24-.21 2.51-.49 3.8-.83a17.94 17.94 0 0 1-5.46 1.27c-9.21.65-13.94-6.31-13.05-12.71zm39.15 10.45c.76-4.11 2.18-8.55 1-9.8-.78-.81-1.3.08-2.54 1.16-.35.3-.72.6-1.11.91-.32 1.63-.78 3.51-1.12 5.32-.76 4.11 1.16 14.36.6 16.77-1.16 5-87.13 5.41-89.85 5.41a4.57 4.57 0 0 1-.83-.07 5.61 5.61 0 0 0 4.62 2.48c2.73 0 88.7-.39 89.86-5.41.52-2.41-1.39-12.66-.63-16.77z"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  className: "8base-girl_svg__cls-3",
  d: "M155.05 533.39c1.43 1.93-6.43 4.26-10.49 6s-17.18 5.42-19 3.79A101.61 101.61 0 0 0 142 533.5c4.71-3.43 8.84-5.83 11.76-7.75-.7 3.67.11 6.06 1.29 7.64z"
});

var _ref23 =
/*#__PURE__*/
React.createElement("g", {
  id: "8base-girl_svg__Hair__Back",
  "data-name": "Hair. Back"
}, React.createElement("path", {
  className: "8base-girl_svg__cls-6",
  d: "M539.49 76.08c-.29 6.4-6.11 9.79-9 10.07-1.12 8.79.44 38.88 1.42 43.41.66 3.12 8.27 22.82 41.25 19.27 9.07-1 13.72-7.44 9.7-11.11-10.46-9.53-.45-27 2.48-33.81 7.42-17.34 5-38.37-6-39.25 2.81-14-5.62-23.16-13.26-21.27-12.88.9-27.37 19.84-26.59 32.69z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-9",
  d: "M585.34 103.91c-2.93 6.85-12.93 24.28-2.48 33.81 3.56 3.25.32 8.7-6.76 10.57-.73-2.76-1.11-5.08-.56-5.65 1.57-1.63 1.91-1.85-3.17-7.92s1.45-23.2 5.66-31.75c3.58-7.27 7.05-25.59 2.05-32.33a3.39 3.39 0 0 0-5.29 0 54.45 54.45 0 0 1-7.92 7.9 1 1 0 0 1-1.46-1.12c4.58-10 2.66-22.47-2-24.85-2.16-1.11-.93-4.92 1.38-9 .44-.07.87-.12 1.31-.15 7.64-1.9 16.07 7.26 13.25 21.26 10.97.86 13.42 21.89 5.99 39.23z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-7",
  d: "M582.08 145.17a15.5 15.5 0 0 1-8.91 3.65c-33 3.55-40.59-16.14-41.26-19.27-1-4.53-2.53-34.62-1.41-43.41 2.88-.28 8.7-3.67 9-10.07-.78-12.85 13.71-31.79 26.64-32.68 3.14 15.53-7.91 35.21-18.61 42.2a6.43 6.43 0 0 0-2.83 5.59c.13 4.1.46 7.78.82 10.45a6.57 6.57 0 0 0 4.23 5.24c5.89 2.26 9 5.53 10.13 8.06 1.33 3 .14 13.78 2.45 16.41 2.82 3.26 12.67-.34 19.75 13.83z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-23",
  d: "M564.84 88.19c1.28-4.09 8.73-12.69 11.73-11.86s-.43 21.59-4.44 26.89-2.84 8.58-4.64 10.3-4.23-20.32-2.65-25.33z"
}));

var _ref24 =
/*#__PURE__*/
React.createElement("g", {
  id: "8base-girl_svg__Top"
}, React.createElement("g", {
  id: "8base-girl_svg__Hand_R",
  "data-name": "Hand R"
}, React.createElement("path", {
  className: "8base-girl_svg__cls-24",
  d: "M282.5 248.57c31.59-8.19 58.3-18.49 92.63-30.55 24-25.55 52.1-68.76 61.64-73.44 9.2-4.52 19.23-7.46 29.09-7.44 9.55 0-20 59.85-20 59.85s-42.8 47.89-51.79 53.34c-6.87 4.17-81.26 20.63-94 23.41-2.62-13.21-6.98-18.29-17.57-25.17z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-25",
  d: "M445.88 197s-42.81 47.89-51.8 53.35c-6.86 4.16-81.25 20.62-94 23.4a53.42 53.42 0 0 0-2.34-8.42c19.62-2.86 77.13-15.38 89.33-22.38 15.5-8.9 51.79-53.34 51.79-53.34s18.86-41.15 27-52.46c9.55 0-19.98 59.85-19.98 59.85z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-25",
  d: "M445.88 197s-20.95 23.44-36.63 39.39a238.22 238.22 0 0 0 5.34-17c-8.38-30.05-6.23-35.43 12.68-53.91 12.94-12.65 23.73-28.28 38.59-28.28 9.55-.06-19.98 59.8-19.98 59.8z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-25",
  d: "M420.68 222.71c-6.63-14.81-12.5-34.5 2.44-47.1 17-14.35 28.35-32 35.48-35.8s-37.92 82.9-37.92 82.9z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-24",
  d: "M267.72 254.49c-1-2.42 4.4-4.69 10.87-7.07 4-1.48 7.31-1.87 10.22-.53 9.41 4.34 18.35 20.5 16.37 25.73-.83 2.19-5.64 3.11-9.91 3.79-4.69.75-8.92 1.11-10.9-.1-.08-5.31-10.57-19.46-16.65-21.82z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-26",
  d: "M267.72 254.49c-1-2.42 4.4-4.69 10.87-7.07 4-1.48 7.31-1.87 10.22-.53 9.41 4.34 18.35 20.5 16.37 25.73-.83 2.19-5.64 3.11-9.91 3.79-4.69.75-8.92 1.11-10.9-.1-.08-5.31-10.57-19.46-16.65-21.82z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-25",
  d: "M305.17 272.62c-.82 2.19-5.63 3.11-9.91 3.79-4.69.75-8.91 1.11-10.89-.1-.08-5.3-10.58-19.46-16.65-21.82a1.85 1.85 0 0 1 .55-2 4.07 4.07 0 0 1 5.44-.36c5.41 4 12.26 13.41 13.67 18.62a2.93 2.93 0 0 0 2.79 2.16 26.63 26.63 0 0 0 8.44-2c2.18-.83 4.63-1.46 6.6-2.18a7.32 7.32 0 0 1-.04 3.89z"
})), React.createElement("g", {
  id: "8base-girl_svg__Shirt"
}, React.createElement("path", {
  className: "8base-girl_svg__cls-24",
  d: "M394.09 292.51h102.22s5.76-19.64 49.94-92.95c7.92-13.14 21.08-41.41 21.24-61.72-7.63-1-11.28-5.39-11.35-7.51-.16-5.48-.55-9.89-.85-12.71-.87-8.18-38.11-19-72.32-1.94-17.77 8.84-17.53 11.84-17.11 21.46-12.81 2.1-13.85 12.12-32 29.86-18.91 18.48-21.06 23.86-12.68 53.91-8.69 31.84-19.1 45.74-27.09 71.6z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-27",
  d: "M538.25 119.28c-10.82 9-31.65 11.61-48.53 10-9.75-1.28-8.41-9.44 3.53-13.25 3.46-1.11 39.24-5 43.16-3.87s3.86 5.15 1.84 7.12z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-27",
  d: "M539.45 117.21a4.57 4.57 0 0 1-1.2 2.06c-10.82 9-31.65 11.61-48.53 10a10.18 10.18 0 0 1-4.73-1.65c-.73-4.24 5.26-7.74 19.79-10 12.53-1.97 33.41-2.86 34.67-.41z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-25",
  d: "M448.71 214.21c-9.06 6.17-20.48 3.49-27.53 6.7-5.61-20.13-6.5-29.19-.79-38.53-10.4 21.89 12.09 23.76 22.66 20.55 5.87-1.78 10.17-4.56 11.29-3.35 2.95 3.2-.82 11.36-5.63 14.63zm95-61.38c-9.56 9-14.81 31.13-19 39.76s-13.28 15.35-26.81 14.51a58.93 58.93 0 0 1-20.11-5.46c-3.66-1.95-5.66 0-5.79 2.38-.84 15.64 22.9 19.09 27 25.27 2.24 3.35-1.4 8.81-8.21 17-1.23 1.47-29.19 3.75-51.37 8.48-5.28 1.12-7.8-1.75-12.05-.88a62.66 62.66 0 0 0-20.35 8.6c-6 4.42 2.31 26.3 2.31 26.3h88.37c3.48-8.55 14.83-33.24 48.55-89.2 7-11.66 9.3-35.81 9.83-55.28-3.76 1.04-7.86 4.24-12.38 8.52z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-25",
  d: "M567.49 137.84c-.17 20.31-13.32 48.58-21.24 61.72-44.18 73.31-49.95 92.95-49.95 92.95h-15.65s8.28-17.69 52.46-91c7.92-13.14 22.95-44.06 23.11-64.37-6.38-.31-5.92-10.11-6-12.23 6.07-10.6-21.5-16.56-36.25-17.9 22.52-2 40.71 4.93 41.31 10.61.3 2.82.68 7.23.85 12.71.07 2.12 3.73 6.5 11.36 7.51z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-27",
  d: "M538.25 119.28c2-2 2.08-6-1.84-7.09s-39.7 2.76-43.15 3.87c-11.95 3.81-13.28 12-3.54 13.25 7.59-2.71 24.48-5.95 48.53-10.03z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-25",
  d: "M473.08 144.28c-4.64-.67-8.73-3.22-9.38-6.68a20.68 20.68 0 0 1 2.16-.46c-.23-5.38-.42-8.69 2.58-12.1-4.14 5 2.72 11.68 11.41 13.67 5.86 1.34-.02 6.55-6.77 5.57z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-28",
  d: "M332.63 236.76c1.2.94 45.6-3.43 50.14-10.08 1.34-2-5.85-5.79-8.19-5.5-5.98.73-43.58 14.28-41.95 15.58z"
})), React.createElement("g", {
  id: "8base-girl_svg__Hand_L",
  "data-name": "Hand L"
}, React.createElement("path", {
  className: "8base-girl_svg__cls-24",
  d: "M556.22 137.14c12.3-1.81 30.06 3.71 24.49 35.21s-21.21 116.41-33.15 116.41H437.24s-9.06-25.38-4.89-26.14c9.83-1.78 48-7.81 88-7.13 3.62.06 7-2.31 7.82-5.21.46-9.36-5.17-108.28 28.05-113.14z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-25",
  d: "M580.71 172.35c-5.57 31.51-21.22 116.41-33.15 116.41H437.24s-1.86-5.19-3.5-10.95c0 0 93.53 4.24 105.11-4.07s26.67-72 27.93-104c1.11-27.85-14.06-29.44-25.76-24.8-10.91 4.32-29.7 6-39.94 2.42-6.86-2.37-4.85-7.17-1.77-7.48 36.12-3.69 52.43-11.77 56-22.26.3 2.82.68 7.23.85 12.71.05 1.77 2.61 5.11 7.88 6.75a22.19 22.19 0 0 1 3.47.76c9.29 2.81 17.17 12.07 13.2 34.51z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-24",
  d: "M420 265.33c-1.38-2.8 16.08-6.48 19.36-4.5 1.15.7 6.7 4.5 13.83 18.34 2.49 4.85.64 9.59-1.58 9.59h-20.36c2.17-9.29-9.68-23.25-11.25-23.43z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-26",
  d: "M420 265.33c-1.38-2.8 16.08-6.48 19.36-4.5 1.15.7 6.7 4.5 13.83 18.34 2.49 4.85.64 9.59-1.58 9.59h-20.36c2.17-9.29-9.68-23.25-11.25-23.43z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-25",
  d: "M451.57 288.76h-20.32c2-8.56-7.92-21.09-10.73-23.14l-.56-.29c-.41-.84.87-1.76 2.94-2.58a4.94 4.94 0 0 1 5.6 1.43c3.44 4.21 7.55 10.7 8.15 16.45a2.72 2.72 0 0 0 2.68 2.49h15c.24 3.19-1.16 5.64-2.76 5.64z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-28",
  d: "M475.74 259.2c7.33-1.74 42.37-2.45 46-2.45 2.35 0 7.67 2.39 5.2 2.71-24.3 3.1-56.94 1.11-51.2-.26z"
})));

var _ref25 =
/*#__PURE__*/
React.createElement("g", {
  id: "8base-girl_svg__Hands"
}, React.createElement("path", {
  className: "8base-girl_svg__cls-13",
  d: "M431.51 286.32a9.61 9.61 0 0 1-.25 2.39h-84.57c-3.23 0-8-6.39 0-11.82 9.57-6.45 33.86-24.64 44.79-22.92 7.45 1.19 20 7 28.44 11.35l.55.29a12.39 12.39 0 0 1 1.59 1.47 45.94 45.94 0 0 1 4 5.06 44.06 44.06 0 0 1 2.65 4.48 21.49 21.49 0 0 1 2.8 9.7z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-14",
  d: "M431.51 286.32a9.61 9.61 0 0 1-.25 2.39h-84.57c-1.68 0-3.78-1.74-4.29-4.18H419c5.06 0 .13-16.4-3.9-18.89A211.46 211.46 0 0 0 391.52 254c7.45 1.19 20 7 28.44 11.35l.55.29a12.39 12.39 0 0 1 1.59 1.47 45.94 45.94 0 0 1 4 5.06 44.06 44.06 0 0 1 2.65 4.48 21.49 21.49 0 0 1 2.76 9.67z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-13",
  d: "M284.38 276.31c-.65.07-1.11.1-1.29.1H209c-2.11 0-5.25-4.55 0-8.38 6.24-4.55 27.47-18.84 34.6-17.62 3.27.56 14.84 3.45 20 4.47a10.24 10.24 0 0 0 4.11-.41c6.07 2.36 16.57 16.52 16.65 21.82z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-14",
  d: "M284.38 276.31c-.65.07-1.11.1-1.29.1H209c-1.51 0-3.54-2.32-2.66-5.05h73.22c.32 0 1.47-.1 3.06-.29a13.35 13.35 0 0 1 1.74 5.24z"
}));

var _ref26 =
/*#__PURE__*/
React.createElement("g", {
  id: "8base-girl_svg__Head"
}, React.createElement("path", {
  className: "8base-girl_svg__cls-13",
  d: "M495.26 100.29c-.53 14.77-5.54 29-5.54 29 16.88 1.58 37.72-1.06 48.53-10a127.45 127.45 0 0 1-4.74-43c1.27-18.8-37.72 9.23-38.25 24z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-29",
  d: "M538.25 119.28a28.6 28.6 0 0 1-3.74 2.62 127.91 127.91 0 0 1-4.62-42.58c.72-10.61-11.4-6.3-22.18 2.12 11.46-10.27 26.59-17 25.79-5.15a127.6 127.6 0 0 0 4.75 42.99z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-29",
  d: "M533.5 76.29a115.65 115.65 0 0 0-.14 12.71 5.17 5.17 0 0 1-2.8 1.67c-2.08 3-17.49 26.19-35.7 15.23.19-1.85.33-3.72.4-5.61.52-14.77 39.51-42.8 38.24-24z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-13",
  d: "M477.48 61.61c1.44 17.7 5.55 36.07 21 42.31s29.9-14.77 32-17.77a10.89 10.89 0 0 0 9-10.07c19.12-22.7 10.1-69.73-21.12-66.48-26.49 2.76-43.2 23.34-40.88 52.01z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-14",
  d: "M539.48 76.08a10.87 10.87 0 0 1-9 10.07c-2.08 3-16.49 24-32 17.77a26.18 26.18 0 0 1-12-9.75c15.85 20.29 37-1.81 40.07-10.08 1.81-4.82 1.83-8.22-4.38-11.64-24.86-13.68-27.38-40-23.46-51.31.93-2.47 59.88 32.24 40.77 54.94z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-14",
  d: "M544.18 69a38.1 38.1 0 0 1-4.7 7.09 10.87 10.87 0 0 1-9 10.07c6.52-1.52 7.39-10.6 2.13-12.89-2.47-1.09 6.09-6.8 11.57-4.27z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-29",
  d: "M489.3 78.93a2.6 2.6 0 0 0-1.3 2.24 1.91 1.91 0 0 0 2.09 2c1.62-.14 3.07-.16 5.61-.15a.84.84 0 0 0 .46-1.56c-2.31-1.36-5.62-3.13-6.86-2.53z"
}));

var _ref27 =
/*#__PURE__*/
React.createElement("g", {
  id: "8base-girl_svg__Hair__Front",
  "data-name": "Hair. Front"
}, React.createElement("path", {
  className: "8base-girl_svg__cls-6",
  d: "M498.78 21.14c-5.23 28.33 26.22 50.58 40.71 54.94 12.16 2.89 26.7-19.57 26.63-32.69.91-15.49-6.66-29.56-22-37.48C518-7.56 492.22 4.58 483 16.56c-7.87 10.26-17.85 17.9-14.53 34.52 1.56 7.84 6.66 11.21 11.16 25.94-5.41-24.27 3.45-45.02 19.15-55.88z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-9",
  d: "M566.12 43.4c.07 13.11-14.47 35.57-26.64 32.68-14.44-4.36-45.93-26.61-40.7-54.94-.58 29.13 34.16 51.86 45.72 47.17 15.36-6.22 30.46-46.49-18.62-68a52.55 52.55 0 0 1 18.23 5.6C559.46 13.83 567 27.9 566.12 43.4z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-7",
  d: "M498.78 21.14C483.07 32 474.22 52.75 479.65 77c-2.85-9.35-5.95-14.12-8.23-18.36-.09-18.59 13.52-32.59 27.36-37.5z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-23",
  d: "M506.51 18.84c.61-6.31 12.13-12.41 20.57-8.94 23.29 9.57 22 35.75 18.24 42.24s-40.61-14.52-38.81-33.3z"
}));

var _ref28 =
/*#__PURE__*/
React.createElement("path", {
  className: "8base-girl_svg__cls-29",
  d: "M507 76.27c-9.12-.14-11.08-4.28-12.29-6.8-1.09-2.27-1.91-3.9-3.29-3.89-.83 0-1.58 1-2.13 3.1s-3.14 8-10.15 6l-.31-.1a71.62 71.62 0 0 0-4.83-11.3c.33-1.9 2.07-3.23 6.75-3.27 4 0 6.83 1.08 8.85 3a2.53 2.53 0 0 0 3.65-.29 7.85 7.85 0 0 1 3.69-3.38c4.32-2 14.77-2 18.36-.5 1.76.73 2.13 2.55 2.4 3.72.4 1.93 1.53 13.91-10.7 13.71z"
});

var _ref29 =
/*#__PURE__*/
React.createElement("path", {
  className: "8base-girl_svg__cls-14",
  d: "M507 73.64c-9.12-.14-11.08-4.28-12.29-6.81-1.09-2.26-1.91-3.9-3.29-3.89-.83 0-1.58 1-2.13 3.11s-3.14 8-10.15 6a5.76 5.76 0 0 1-1.45-.62 71.42 71.42 0 0 0-3.69-8.06c0-.63-.07-1.18-.1-1.61-.18-2.49 1.25-4.45 6.8-4.38s7.24 1 8.85 3a2.45 2.45 0 0 0 3.65-.29 7.88 7.88 0 0 1 3.69-3.37c4.32-2 14.77-2 18.36-.51 1.76.73 2.13 2.55 2.4 3.72.45 1.92 1.58 13.9-10.65 13.71z"
});

var _ref30 =
/*#__PURE__*/
React.createElement("path", {
  d: "M473.91 62.92c-.17-2.48 1.26-4.33 6.8-4.38 5.72.13 7.47 1.34 8.86 3a2.45 2.45 0 0 0 3.65-.28 7.75 7.75 0 0 1 3.69-3.38c4.31-2 14.77-2 18.35-.5 1.76.73 2.13 2.55 2.4 3.72.45 1.9 1.57 13.9-10.61 13.7-9.13-.14-11.09-4.28-12.3-6.8-1.08-2.27-1.9-3.9-3.29-3.89-.83 0-1.57 1-2.13 3.1s-3.14 8-10.15 6c-5.12-1.45-5.09-7.8-5.27-10.29z",
  fill: "#683729"
});

var _ref31 =
/*#__PURE__*/
React.createElement("path", {
  d: "M495.28 64.4a4.21 4.21 0 0 1 2.83-4.53c7.11-2.17 17.16-1.28 18 1.61 1.18 3.81-.07 11.8-8 12.16-6.94.36-12.54-2.1-12.83-9.24zm-20.47-1.12c-.35 2.32.43 8.69 5.93 9.38 6.66.83 7.64-6.14 7.79-7.68.34-3.27-4-4.3-6.68-4.37-3.8-.1-6.75.74-7.04 2.67z",
  fill: "#baebff"
});

var _ref32 =
/*#__PURE__*/
React.createElement("path", {
  id: "8base-girl_svg__Shadow__Neck",
  "data-name": "Shadow. Neck",
  className: "8base-girl_svg__cls-27",
  d: "M538.25 119.28c-10.82 9-31.65 11.61-48.53 10-6.09-.8-7.85-4.28-5.41-7.71-.23 3 3.77 6.7 25.07 4.17s29.38-7 30.07-10.83a4.49 4.49 0 0 1-1.2 4.37z"
});

var _ref33 =
/*#__PURE__*/
React.createElement("g", {
  id: "8base-girl_svg__Table"
}, React.createElement("rect", {
  className: "8base-girl_svg__cls-20",
  y: 288.76,
  width: 901.54,
  height: 14.33,
  rx: 4
}), React.createElement("path", {
  className: "8base-girl_svg__cls-22",
  d: "M901.54 292.76v6.32a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4v-1.93h891.61a4 4 0 0 0 4-4v-4.39h1.93a4 4 0 0 1 4 4z"
}));

var _ref34 =
/*#__PURE__*/
React.createElement("g", {
  id: "8base-girl_svg__Computer"
}, React.createElement("path", {
  className: "8base-girl_svg__cls-34",
  d: "M388.51 276.41h-200.7a8 8 0 0 0-8 8v4.36H396.5v-4.33a8 8 0 0 0-7.99-8.03z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-35",
  d: "M396.5 284.43v4.33H179.8v-4.9h204.45a3 3 0 0 0 3-3v-1.33a8 8 0 0 0-.62-3.1h1.87a8 8 0 0 1 8 8z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-35",
  d: "M213.19 288.76h-29.9v-4.36a8 8 0 0 1 8-8h19.92z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-34",
  d: "M197.07 269.91L104 269a6 6 0 0 0-6 5.1l-2.22 14.66h108.51L202 274.12a5 5 0 0 0-4.93-4.21z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-35",
  d: "M204.29 288.76H95.81l.82-5.43h92.88a5 5 0 0 0 4.94-5.79l-1.23-7.67h3.84a5 5 0 0 1 4.89 4.21z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-34",
  d: "M188.92 240.89l-77.25-3.58a5 5 0 0 0-5.21 4.53l-1.17 12.74a4 4 0 0 0 3.94 4.36l81.48.9a4 4 0 0 0 4-4.42l-1.07-10.07a5 5 0 0 0-4.72-4.46z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-35",
  d: "M194.73 255.42a4 4 0 0 1-4 4.42l-81.47-.9a4 4 0 0 1-3.94-4.36l.18-2 79.07.87a4 4 0 0 0 4-4.42l-.87-8.22 1.22.06a5 5 0 0 1 4.74 4.46z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-34",
  d: "M270.39 232h-14.05l-.13-185.9h14.05a10 10 0 0 1 10.57 10V222a10 10 0 0 1-10.44 10z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-35",
  d: "M270.39 232h-14.05l-.13-185.9h14.05a10 10 0 0 1 10.57 10V222a10 10 0 0 1-10.44 10z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-35",
  d: "M270.39 232h-14.05l-.13-185.9h14.05a10 10 0 0 1 10.57 10V222a10 10 0 0 1-10.44 10z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-34",
  d: "M256.34 232l-209.68-9.18a10 10 0 0 1-9.56-10V68a10 10 0 0 1 9.43-10l209.68-11.9a10 10 0 0 1 10.56 10V222a10 10 0 0 1-10.43 10z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-35",
  d: "M256.34 232l-209.68-9.18a10 10 0 0 1-9.56-10V68a10 10 0 0 1 9.43-10l209.68-11.9a10 10 0 0 1 10.56 10V222a10 10 0 0 1-10.43 10zm-.07-12.3V59.41a7 7 0 0 0-7.39-7L48.44 63.78a6 6 0 0 0-5.66 6v142.04a5 5 0 0 0 4.78 5L250 225.64a6 6 0 0 0 6.27-5.99z"
}), React.createElement("ellipse", {
  className: "8base-girl_svg__cls-36",
  cx: 143.77,
  cy: 143.95,
  rx: 52.78,
  ry: 53.4,
  transform: "rotate(-49.01 143.785 143.944)"
}), React.createElement("ellipse", {
  className: "8base-girl_svg__cls-37",
  cx: 143.23,
  cy: 140.76,
  rx: 51.45,
  ry: 52.05,
  transform: "rotate(-49.01 143.234 140.765)"
}), React.createElement("ellipse", {
  className: "8base-girl_svg__cls-38",
  cx: 143.23,
  cy: 140.76,
  rx: 44.84,
  ry: 45.37,
  transform: "rotate(-49.01 143.234 140.765)"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-37",
  d: "M123.29 152.46a16 16 0 0 1 8.79-15.05c-3.4-3.27-5.51-6.54-5.56-11.35a16.09 16.09 0 0 1 16.35-16.52 16.47 16.47 0 0 1 16.64 16.52c.06 4.81-1.89 8.08-5.21 11.35a16.47 16.47 0 0 1 9.14 15.05c.12 10.84-9.17 19.44-19.85 19.44s-20.08-8.6-20.3-19.44zm10.86 0a9.35 9.35 0 0 0 9.32 9.21 9.1 9.1 0 0 0 9.11-9.21 9.35 9.35 0 0 0-9.32-9.2 9.09 9.09 0 0 0-9.11 9.2zm2.54-26.23a6.55 6.55 0 0 0 6.44 6.36 6.3 6.3 0 0 0 6.22-6.36 6.5 6.5 0 0 0-6.37-6.45 6.32 6.32 0 0 0-6.29 6.45z"
}));

var _ref35 =
/*#__PURE__*/
React.createElement("g", {
  id: "8base-girl_svg__Laptop"
}, React.createElement("path", {
  className: "8base-girl_svg__cls-34",
  d: "M698.18 288.76h-140.7a8 8 0 0 1-8-8v-2.36a2 2 0 0 1 2-2h154.7v4.33a8 8 0 0 1-8 8.03z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-35",
  d: "M706.17 280.74a8 8 0 0 1-8 8H557.48a8 8 0 0 1-8-8 8 8 0 0 0 6.58 3.45h140.69a8 8 0 0 0 8-7.8h1.41z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-35",
  d: "M706.15 281.31a8 8 0 0 1-8 7.45h-80.63a5 5 0 0 1-4.73-6.63l2-5.72h14.67l-.32.93a3 3 0 0 0 2.84 4z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-34",
  d: "M788.82 182.27H659.36a10 10 0 0 0-9.46 6.73L618 282.13a5 5 0 0 0 4.73 6.63h130.9a8 8 0 0 0 7.56-5.41l32.4-94.45a5 5 0 0 0-4.77-6.63z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-35",
  d: "M793.55 188.9l-32.4 94.45a8 8 0 0 1-7.56 5.41h-130.9a5 5 0 0 1-4.73-6.63L649.9 189a10 10 0 0 1 9.46-6.76h129.46a5 5 0 0 1 4.73 6.66zm-9.9.82H670.47a8.59 8.59 0 0 0-8.14 5.81l-28.06 81.81a3 3 0 0 0 2.84 4h115a6 6 0 0 0 5.68-4.05l28.66-83.57a3 3 0 0 0-2.8-4z"
}), React.createElement("ellipse", {
  className: "8base-girl_svg__cls-36",
  cx: 711.3,
  cy: 238.28,
  rx: 39.84,
  ry: 31.13,
  transform: "rotate(-41.48 711.24 238.282)"
}), React.createElement("ellipse", {
  className: "8base-girl_svg__cls-37",
  cx: 712.16,
  cy: 236.17,
  rx: 38.83,
  ry: 30.34,
  transform: "rotate(-41.48 712.098 236.176)"
}), React.createElement("ellipse", {
  className: "8base-girl_svg__cls-38",
  cx: 712.16,
  cy: 236.17,
  rx: 33.84,
  ry: 26.45,
  transform: "rotate(-41.48 712.098 236.176)"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-37",
  d: "M707.05 256.84c-7.08 0-11.9-5.71-10.12-12.91a14.87 14.87 0 0 1 8.41-10 8 8 0 0 1-1.68-7.53c1.53-6.17 7.45-11 13.62-11s9.78 4.8 8.25 11c-.79 3.19-2.69 5.36-5.46 7.53 3.38 2.06 4.56 5.6 3.47 10-1.84 7.2-9.41 12.91-16.49 12.91zm4.7-19a8.33 8.33 0 0 0-7.62 6.1c-.84 3.37 1.23 6.11 4.6 6.11a8.35 8.35 0 0 0 7.62-6.11c.83-3.37-1.23-6.11-4.6-6.11zm3.85-15.59a5.82 5.82 0 0 0-5.23 4.28 3.21 3.21 0 0 0 3.13 4.23 5.88 5.88 0 0 0 5.27-4.23 3.23 3.23 0 0 0-3.17-4.29z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-35",
  d: "M647.93 266.82c-.28-5.38-6.25-9.67-12.6-6.57v-1.53c0-1.93-3.63-2.82-8.25-3.23L618 282.13a5 5 0 0 0 4.73 6.63h8.47c1.37-2.42 2.45-6.27 3.17-11.6 4 1.69 14.08-.49 13.56-10.34zm-13.15 6.28c.21-2.4.37-5 .46-7.9 3-3.12 8.49-2.21 8.61 2.18.15 3.7-3.6 7.84-9.07 5.72z"
}));

var _ref36 =
/*#__PURE__*/
React.createElement("path", {
  className: "8base-girl_svg__cls-10",
  d: "M641.74 263.76c-.28-5.38-6.25-9.67-12.6-6.57v-1.53c0-3.91-14.86-3.54-22.78-3.54s-22.79-.37-22.79 3.54c0 22.29 3.21 33.1 8.26 33.1h29.07c3.37 0 5.91-4.82 7.24-14.66 4.04 1.69 14.12-.49 13.6-10.34zM628.59 270c.21-2.4.37-5 .46-7.9 3-3.12 8.49-2.21 8.61 2.18.11 3.72-3.6 7.88-9.07 5.72z"
});

var _ref37 =
/*#__PURE__*/
React.createElement("path", {
  className: "8base-girl_svg__cls-39",
  d: "M628.14 274.1c.07-.53.14-1.07.2-1.63 8.58 2.94 15.35-6 11.55-13.34a7.91 7.91 0 0 1 1.85 4.64c.52 9.84-9.56 12.02-13.6 10.33zm1-13.86c0 .65 0 1.28-.05 1.9 2.54-2.67 6.93-2.39 8.24.48-1.08-2.51-4.16-4.48-8.23-2.38z"
});

var _ref38 =
/*#__PURE__*/
React.createElement("path", {
  className: "8base-girl_svg__cls-39",
  d: "M629.15 255.66c0 22.29-3.21 33.1-8.25 33.1h-29.06c-1.85 0-3.44-1.44-4.72-4.35h28.12c4.93 0 8.11-10.35 8.24-31.67 3.32.49 5.67 1.37 5.67 2.92z"
});

var _ref39 =
/*#__PURE__*/
React.createElement("path", {
  d: "M605.22 246.8c7.57-.83 11.9-8 7.31-13.07-3-3.38-10.45-4.16-16-9.1-5.21-4.67-4.17-14.53 4.56-19C616 198 612.41 187 605.73 186.05c5.8-.67 14.4 5.11 16.36 12.36 1.34 5 0 9-5.1 12.83-4 3-4 7-1.65 9.62 3.27 3.71 8.43 4.92 9.46 11.77.98 6.51-4.63 13.76-19.58 14.17z"
});

var _ref40 =
/*#__PURE__*/
React.createElement("g", {
  id: "8base-girl_svg__Books"
}, React.createElement("path", {
  className: "8base-girl_svg__cls-34",
  d: "M879.26 285.45q-8.19-9.42 0-18.84h-89.9v18.84z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-35",
  d: "M875.17 276q0 4.71 4.09 9.42h-89.9V276h78.11q0-4.71 4.1-9.42h7.69q-4.09 4.74-4.09 9.42z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-6",
  d: "M783 275.79a13 13 0 0 1 13.1-12.49h87.07a1 1 0 0 1 1 1.31c-.56 1.45-2.2 2-4.87 2h-79.68a9.64 9.64 0 0 0-9.72 8.79 9.42 9.42 0 0 0 9.39 10.05h80c2.67 0 4.31.56 4.87 2a1 1 0 0 1-1 1.31h-87.5A12.73 12.73 0 0 1 783 275.79z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-35",
  d: "M802.94 285.45h-4.47a9.41 9.41 0 0 1-9.39-10.05 9.63 9.63 0 0 1 9.72-8.79h4.47a9.62 9.62 0 0 0-9.72 8.79 9.41 9.41 0 0 0 9.39 10.05z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-7",
  d: "M884.12 287.45a1 1 0 0 1-1 1.31h-87.5a12.72 12.72 0 0 1-11.18-6.64 12.7 12.7 0 0 0 10.08 5h87.5a1 1 0 0 0 1-.88 2.51 2.51 0 0 1 1.1 1.21zM789.9 275.4a9.63 9.63 0 0 1 9.72-8.79h79.64c2.67 0 4.3-.55 4.86-2a1 1 0 0 0-1-1.31h-.32c-.68 1.17-2.26 1.64-4.68 1.64h-79.6a9.64 9.64 0 0 0-9.72 8.79 9.38 9.38 0 0 0 2.12 6.61 9.32 9.32 0 0 1-1.02-4.94z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-34",
  d: "M888.83 260q-8.19-9.42 0-18.84h-89.91V260z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-35",
  d: "M884.73 250.57q0 4.71 4.09 9.42h-89.9v-9.42H877q0-4.71 4.1-9.42h7.69q-4.06 4.71-4.06 9.42z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-6",
  d: "M792.51 250.33a13 13 0 0 1 13.15-12.49h87.07a1 1 0 0 1 1 1.31c-.56 1.45-2.2 2-4.86 2h-79.69a9.64 9.64 0 0 0-9.72 8.79 9.42 9.42 0 0 0 9.39 10.06h80c2.66 0 4.3.56 4.86 2a1 1 0 0 1-1 1.31h-87.47a12.73 12.73 0 0 1-12.73-12.98z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-35",
  d: "M812.5 260H808a9.41 9.41 0 0 1-9.39-10.05 9.63 9.63 0 0 1 9.72-8.79h4.47a9.62 9.62 0 0 0-9.72 8.79A9.41 9.41 0 0 0 812.5 260z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-7",
  d: "M893.68 262a1 1 0 0 1-.95 1.31h-87.5a12.72 12.72 0 0 1-11.18-6.64 12.7 12.7 0 0 0 10.08 5h87.5a1 1 0 0 0 1-.88 2.51 2.51 0 0 1 1.05 1.21zm-94.22-12.05a9.63 9.63 0 0 1 9.72-8.79h79.64c2.67 0 4.3-.55 4.86-2a1 1 0 0 0-.95-1.31h-.32c-.68 1.17-2.26 1.64-4.68 1.64h-79.65a9.64 9.64 0 0 0-9.72 8.79 9.38 9.38 0 0 0 2.12 6.61 9.32 9.32 0 0 1-1.02-4.95z"
}));

var _ref41 =
/*#__PURE__*/
React.createElement("path", {
  className: "8base-girl_svg__cls-10",
  d: "M815.88 237.84a5 5 0 0 1-4.27-2.38c-5.18-8.49-7.53-17.87-8.27-27.77a3 3 0 0 1 3-3.23h57.83a3 3 0 0 1 3 3.23c-.74 9.9-3.09 19.28-8.27 27.77a5 5 0 0 1-4.27 2.38z"
});

var _ref42 =
/*#__PURE__*/
React.createElement("path", {
  className: "8base-girl_svg__cls-11",
  d: "M867.16 207.69c-.74 9.9-3.09 19.28-8.26 27.77a5 5 0 0 1-4.27 2.38h-38.75a5 5 0 0 1-4.27-2.38c-.64-1.05-1.23-2.11-1.78-3.18a4.66 4.66 0 0 0 1.13.13h38.75A5 5 0 0 0 854 230c4.79-7.85 7.16-16.47 8.07-25.56h2.12a3 3 0 0 1 2.97 3.25z"
});

var _ref43 =
/*#__PURE__*/
React.createElement("g", {
  id: "8base-girl_svg__Plant"
}, React.createElement("path", {
  className: "8base-girl_svg__cls-43",
  d: "M804.15 135.31c8.11 21.19 46.92 26.15 34.26 69.15h-13.35c-20.98-4.78-41.56-38.2-20.91-69.15z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-44",
  d: "M838.41 204.46h-13.35a31.48 31.48 0 0 1-12.44-6.24c3.74 1.75 6-1.88 3-5.3-13.23-15.26-16.72-37.4-11.5-57.61 8.14 21.19 46.95 26.15 34.29 69.15z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-44",
  d: "M838.41 204.46H830c-18-19.47-25.47-38.24-23.24-64.21 11.55 17.33 43.24 24.75 31.65 64.21z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-43",
  d: "M847.89 204.46c25.07-30.17 56.87-69.57 26.63-126.8-15.36 32-69.94 62.61-33.73 126.8z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-45",
  d: "M847.89 204.46h-10.48c-11.24-48.58 58.59-58.13 37.35-126.32 29.82 56.97-1.87 96.23-26.87 126.32z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-44",
  d: "M858.19 191.78c-3.44 4.41-6.93 8.63-10.3 12.68h-7.11c-26.6-47.15-4.21-76.18 15.64-100.95 14.07 29.76 17.95 59.32 1.77 88.27z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-43",
  d: "M836.4 204.46c-62.73-65.53-2.83-117.87-.36-148 38.11 59.26 24.79 132.14 7.83 148z"
}), React.createElement("path", {
  className: "8base-girl_svg__cls-45",
  d: "M843.87 204.46h-7.09c-18.07-49 31.58-65.05-.75-148 38.12 59.31 24.8 132.2 7.84 148z"
}));

var Svg8BaseGirl = function Svg8BaseGirl(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 901.54 584.79"
  }, props), _ref, React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, React.createElement("g", {
    id: "8base-girl_svg__Layer_2",
    "data-name": "Layer 2"
  }, React.createElement("g", {
    id: "8base-girl_svg__Girl"
  }, _ref2, React.createElement("g", {
    id: "8base-girl_svg__Chair"
  }, React.createElement("g", {
    id: "8base-girl_svg__Leg"
  }, _ref3, _ref4, React.createElement("path", {
    d: "M497.51 561.44h-31.63c8 0 13-10.84 4.47-17.62-8.89-7.09-26.14-12.2-33-13.92a3.37 3.37 0 0 1-2.54-3.07 6.17 6.17 0 0 0-2.29-4.81 4 4 0 0 1-1.63-3.53c1-10.43 4.06-48.36 5.69-68.35 1.84-22.57-10.67-20.72-17.91-18.13-1-8.88-1.74-14.26-1.74-14.26a10 10 0 0 1-9.85-8.25l-.53-3h52.13l-.53 3a10 10 0 0 1-9.85 8.25s-7.48 54.65-7.48 103.31c2 0 6.48 0 6.48 5.59v2.73c23.12.8 48.2 9.34 56.2 16.76 5.04 4.69 4.31 15.3-5.99 15.3z",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fill: "#e7ebf2"
  })), _ref5, _ref6, React.createElement("path", {
    d: "M571.13 230.48c-2.35 16.73-9.26 42.13-16.11 64.22 0 .11-.07.22-.11.33-8.43 25-30.83 28.61-43 31.49-8 1.9-14.71 7.87-19.18 17.46-8.06 17.26-15.25 37.65-19.53 45.67-6.59 12.32-13.6 16.84-24.89 16.84h-70.2c-17.08 0-29.23-12.35-32-30.35s-3.21-30.94-3.21-47.78c0-11.81 11.17-17.19 38.81-27.49 6.13-2.28 14.45-29.57 21.84-44.73 1.93-3.94 4.93-10.93 8.57-18.2-15.54 34.49-19.07 62.62-27.94 65.88-24 8.83-35.23 14.35-35.23 24.07 0 13.76 1 43 4.74 52.26 5.36 13.22 12.17 17.67 26.56 18s54.37.07 64.27.14c18.48.14 24.48-20.38 29.27-32.29 7.2-17.81 15.75-40 36.07-44.72 21-4.85 33.25-9.46 38-20.42 5.14-11.58 13.14-38.8 17.2-59.86 2.86-14.88 4.41-25.82-.8-28.13 7.36 2.88 8.08 9.05 6.87 17.61zM531 357.53c-.58-2.83-3.1-5.47-9.73-7-2.46.8-4.31 1.37-5.74 1.84 5 .94 12.69 3.1 10.75 7-1.51 3-13.33 8-20.54 7.63a3.4 3.4 0 0 0 1.24 2.24c3.46 2.63 25.22-3.67 24.02-11.71z",
    style: {
      mixBlendMode: "screen"
    },
    fill: "#805743"
  }), _ref7, _ref8, _ref9), React.createElement("g", {
    id: "8base-girl_svg__Girl-2",
    "data-name": "Girl"
  }, React.createElement("g", {
    clipPath: "url(#8base-girl_svg__clip-path)",
    id: "8base-girl_svg__Legs"
  }, _ref10, _ref11, _ref12, _ref13, _ref14, React.createElement("path", {
    d: "M114.67 556.67c-7.87 2.16-57.47 2-77.51 1.59a15 15 0 0 1 5.58-3.12l11.55-3.07 61.25-2c.85.77.86 6.13-.87 6.6z",
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#343434",
    opacity: 0.5
  }), _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22), _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, React.createElement("path", {
    d: "M507.78 73.28c-7 .33-12.58-2.1-12.88-9.24a4.23 4.23 0 0 1 2.84-4.53c7.1-2.17 17.15-1.28 18 1.61 1.26 3.81-.03 11.8-7.96 12.16zm-26.31-13c-3.79-.1-6.74.73-7 2.67-.35 2.32.43 8.69 5.93 9.38 6.66.83 7.63-6.14 7.79-7.68.3-3.3-4.06-4.33-6.72-4.4zm11.92 5.2c-.57-.84-1.16-1.35-1.93-1.34s-1.58 1-2.13 3.1-3.14 8-10.15 6a6 6 0 0 1-3.68-2.88 6 6 0 0 0 3.41 2.45c7 2 9.6-3.9 10.15-6s1.3-3.1 2.13-3.1 1.55.64 2.2 1.74zm24.27-4.34a6.94 6.94 0 0 0-1-2.57 8.19 8.19 0 0 1 .7 2.14c.44 1.91 1.57 13.88-10.62 13.69-6.84-.1-9.65-2.46-11.14-4.7 1.41 2.35 4.12 5 11.41 5.13C519.23 75 518.1 63 517.66 61.11z",
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#683729",
    opacity: 0.5
  }), _ref31, React.createElement("path", {
    d: "M481.84 60.61c-3.79-.1-6.74.74-7 2.67a7.44 7.44 0 0 0-.06 1.48c4-.46 9.3-.72 13.71.81 0-.24.05-.44.07-.59.3-3.27-4.06-4.3-6.72-4.37zm34.69 3.79c-4.17-1.3-18.11-1.13-21.26 0a4.21 4.21 0 0 1 2.84-4.52c7.1-2.18 17.15-1.29 18 1.6a9.9 9.9 0 0 1 .42 2.92z",
    style: {
      mixBlendMode: "screen"
    },
    fill: "#baebff",
    opacity: 0.5
  }), _ref32), React.createElement("g", {
    id: "8base-girl_svg__Desk"
  }, _ref33, _ref34, _ref35, React.createElement("g", {
    id: "8base-girl_svg__Cup"
  }, _ref36, _ref37, _ref38, React.createElement("path", {
    d: "M617.83 252.24c-4.4 31.08-29.9 26.45-33.31 19.76a3.32 3.32 0 0 1-.24-.59 156.85 156.85 0 0 1-.69-15.74c0-3.91 14.86-3.54 22.79-3.54 3.16-.01 7.45-.07 11.45.11z",
    style: {
      mixBlendMode: "screen"
    },
    fill: "#f4bd0f",
    opacity: 0.25
  })), React.createElement("g", {
    id: "8base-girl_svg__Steam",
    fill: "#eff5f9"
  }, _ref39, React.createElement("path", {
    d: "M605.22 246.81c10.47-1.08 14.26-7.67 13.42-13.26-1-6.85-10.58-7.73-12.27-14.21-2.77-10.64 10.6-11.87 10.3-20.67-.14-4.23-4.84-11.9-10.3-12.66 5.77-.2 13.83 5.41 15.71 12.4 1.35 5 0 9-5.09 12.84-4 3-4 7-1.65 9.61 3.26 3.71 8.42 4.92 9.45 11.77.98 6.51-4.63 13.76-19.57 14.18z",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  })), _ref40, _ref41, _ref42, _ref43)))));
};

export default __webpack_public_path__ + "static/media/8base-girl.8bbbfad5.svg";
export { Svg8BaseGirl as ReactComponent };